<template>
    <b-container fluid>
      <PortalNavbar show="true"></PortalNavbar>
        <div class="body-content">
            <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
            <b-alert :show = "showDismissibleAlert" dismissible 
                @dismissed="showDismissibleAlert=false"
                :variant="variant">
                {{alertText}}
            </b-alert>
            <b-row>
              <b-col md="3"></b-col>
              <b-col>
                <b-table show-empty head-variant="dark"
                        empty-text="Loading..."
                          stacked="md"
                          bordered
                          striped
                          :items="schemeEligibility"
                          :fields="fields"
                          style="font-size:12px"
                        
                >
                    <template v-slot:cell(action)="row">
                      <a  target="_blank" href="" class="mr-1 pt-0 pb-0">Download</a>
                        <!-- <b-button size="sm" @click.stop="applyforScheme(row.item, row.index, $event.target)" 
                          class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Apply for the post">
                          Download
                        </b-button> -->
                    </template>
                </b-table>
              </b-col>
              <b-col md="3"></b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import PortalNavbar from "@/components/PortalNavbar";
export default {
  name: "download2",
  components: { Spinner, PortalNavbar },
  data() {
    return {
      inputSchemeID: 1,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      schemeEligibility: [
        {
          SrNo: "",
          Document: ""
        }
      ],
      fields: [
        {
          key: "DocType",
          label: "Document",
          sortable: true
        },
        {key:"action", label:"Download"}
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedSchemeId: "",
      RegType: 1
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    //   getSchemeEligibility() {
    //   let promise = apis.getDownloads();

    //   promise
    //     .then(response => {
    //       if (response.status == 200) {
    //         let rspns = response.body;
    //         //this.$store.dispatch("setSchemeList", rspns);
    //         this.schemeEligibility=response.body;
            
    //       } else {
    //         this.alertText = "Unable to Load Scheme List, " + response.body;

    //         this.variant = "warning";
    //         this.showDismissibleAlert = true;
    //       }
    //       this.isLoading = false;
    //     })
    //     .catch(err => {
    //       this.alertText = "Unable to Load Scheme List, " + err.message;
    //       this.showDismissibleAlert = true;
    //       this.variant = "danger";
    //       this.isLoading = false;
    //     });
    //}
  },
  mounted() {
    this.schemeEligibility = [];
    this.getSchemeEligibility();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Portal/Download2.vue